import React, { useEffect, useState } from "react";
import { Button } from "antd";

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    if (choice.outcome === "accepted") console.log("App installed");
    setShowButton(false);
  };

  return (
    showButton && (
      <Button type="primary" onClick={handleInstallClick}>
        📲 Install App
      </Button>
    )
  );
};

export default InstallPrompt;
